import PropTypes from 'prop-types';
import { Link } from '@blaze-cms/nextjs-components';
import { Fragment } from 'react';

const YachtDescriptionBlock = ({ block }) => {
  const splitBlock = block.split('{{boat_pro_link}}');

  return (
    <>
      {splitBlock[0]}
      {splitBlock.slice(1, splitBlock.length).map(singleSplitBlock => (
        <Fragment key={singleSplitBlock}>
          <Link href="/boat-pro">BOATPro AIS</Link>
          {singleSplitBlock}
        </Fragment>
      ))}
    </>
  );
};

YachtDescriptionBlock.propTypes = {
  block: PropTypes.string.isRequired
};

export default YachtDescriptionBlock;
